import src from "IMAGE";
export default { src, width: 123, height: 54, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
